// extracted by mini-css-extract-plugin
export default {"privacy-zones-legend":"ActivityDetailsMap--privacy-zones-legend--E1SIN","privacyZonesLegend":"ActivityDetailsMap--privacy-zones-legend--E1SIN"};